import type { SVGProps } from "react";
export default function SvgCheck(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-check-icon lucide-check"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M20 6 9 17l-5-5" />
		</svg>
	);
}
